<template>
    <app-modal-view @close="$store.dispatch('closeLoginForm')">
        <template #body>
            <login-form />
        </template>
    </app-modal-view>
</template>

<script>
import AppModalView from '@/components/AppModalView';
import LoginForm from '@/components/UserLoginForm';
export default {
    components: {
        AppModalView,
        LoginForm,
    },
};
</script>

<style></style>
